import { ClassicCard, getUser, initialize, subscribeToContentCardsUpdates, changeUser, openSession, requestContentCardsRefresh, logCardDismissal, logCustomEvent, logContentCardImpressions } from '@braze/web-sdk';
import { AppSettings } from '../../models/AppSettings';
import BrazeCustomerLead from '../../models/BrazeCustomerLead';

export const initBraze = async (appSettings: AppSettings, setContentCardsCallback: (cards: ClassicCard[]) => void) => {
    // initialize the SDK
    initialize(appSettings.braze.sdkApiKey, {
        baseUrl: appSettings.braze.sdkEndpoint,
        enableLogging: false, // set to `true` for debugging
        allowUserSuppliedJavascript: false, // set to `true` to support custom HTML messages
    });

    subscribeToContentCardsUpdates((cards) => {
        if (localStorage.getItem('token') !== null) {
            setContentCardsCallback(cards.cards as ClassicCard[]);
        }
    });

    //120000ms = 2 minute
    setInterval(() => {
        if (localStorage.getItem('token') !== null) {
            requestContentCardsRefresh();
        }
    }, 120000);

    // `openSession` should be called last
    openSession();
}

export const trackBrazeUser = (accountId: string) => {
    changeUser(accountId);
    requestContentCardsRefresh();
}

export const dismissContentCard = (cardToDismiss: ClassicCard) => {
    logCardDismissal(cardToDismiss);
}

export const submitLimiterContent = (customerLead: BrazeCustomerLead) => {
    const brazeUserId = getUser()?.getUserId();
    if (brazeUserId) {
        logCustomEvent("limiter_form_completed");
    } else {
        getUser()?.setEmail(customerLead.email);
        getUser()?.setPhoneNumber(customerLead.mobilePhone);
        getUser()?.setFirstName(customerLead.firstName);
        getUser()?.setLastName(customerLead.surname);
        logCustomEvent("limiter_form_completed");
    }
}

export const logUserHasSeenContentCard = (contentCards: ClassicCard[]) => {
    logContentCardImpressions(contentCards);
}